export default "__VITE_ASSET__DJoy4dYf__"